import { Component } from '@angular/core';

import { ClaimsService } from '@core/authentication/claims.service';
import { AggregatorFeatureFlagService } from '@core/services/aggregator-feature-flag.service';
import { FeatureFlagService } from '@core/services/feature-flag.service';
import { AggregatorFeatureFlag } from '@env/aggregator/aggregator.interface';
import { FeatureFlag } from '@env/environment.interface';
import {
  SideBarItem,
  SidebarVisibility
} from '@shared/components/menu/sidebar-nav/sidebar-nav.model';

@Component({
  selector: 'spark-shared-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent {
  readonly mainMenuItems: SideBarItem[][] = [
    [
      new SideBarItem('Dashboard', 'dashboard', 'window'),
      new SideBarItem('Tasks', 'Tasks', 'tasks')
    ],
    [
      new SideBarItem('Leads', 'Leads', 'users'),
      new SideBarItem('Contacts', 'Contacts', 'address-book'),
      new SideBarItem('Opportunities', 'Opportunities', 'id-card')
    ],
    [
      new SideBarItem(
        'Products Matrix',
        'products-matrix',
        'funds',
        this.getProductMatrixVisibility()
      ),
      new SideBarItem(
        'Calculators',
        'calculators',
        'calculator',
        this.getCalculatorsVisibility()
      )
    ],
    [
      new SideBarItem('Provider Library', 'library/provider', 'institution'),
      new SideBarItem('My Library', 'library/personal', 'document'),
      new SideBarItem(
        'Reports',
        'reports',
        'report',
        this.getReportsVisibility()
      )
    ]
  ];

  constructor(
    public claimsService: ClaimsService,
    private readonly featureFlagService: FeatureFlagService,
    private readonly aggregatorFeatureFlagService: AggregatorFeatureFlagService
  ) {}

  private getReportsVisibility(): SidebarVisibility {
    if (
      this.aggregatorFeatureFlagService.isEnabled(
        AggregatorFeatureFlag.Reports
      ) &&
      this.featureFlagService.isEnabled(FeatureFlag.Reports)
    ) {
      return 'show';
    }
    return 'hide';
  }

  private getProductMatrixVisibility(): SidebarVisibility {
    if (
      this.aggregatorFeatureFlagService.isEnabled(
        AggregatorFeatureFlag.ProductMatrix
      ) &&
      this.featureFlagService.isEnabled(FeatureFlag.ProductMatrix)
    ) {
      return 'show';
    }
    return 'hide';
  }

  private getCalculatorsVisibility(): SidebarVisibility {
    if (
      this.aggregatorFeatureFlagService.isEnabled(
        AggregatorFeatureFlag.Calculators
      )
    ) {
      return 'show';
    }
    return 'hide';
  }
}
